import React, { useEffect } from 'react';
import { Form, InputNumber, Row, Col, Input } from 'antd';

const VitalsInputForm = ({ form, initialData }) => {
  // Note: This component expects the Ant Design form instance to be passed as a prop.
  // Validation and submission logic will be handled by the parent component.

  useEffect(() => {
    if (initialData) {
      // Ensure keys in initialData match form item names
      // e.g., initialData might be { bloodPressureSystolic: '120', heartRate: '80', ... }
      form.setFieldsValue(initialData);
    } else {
      form.resetFields(); // Reset if no initial data (e.g., for new entry)
    }
  }, [form, initialData]);

  return (
    <Form form={form} layout="vertical" name="vitals_input_form">
      {/* Layout similar to the original UpdateVitalsModal */}
      <Row gutter={16}>
        {/* BP */}
        <Col xs={12} sm={8} md={6}>
          <Form.Item label="BP (Sys/Dia)">
            <Input.Group compact>
              <Form.Item name="vitals_sbp" noStyle>
                <InputNumber style={{ width: '50%' }} placeholder="Sys" />
              </Form.Item>
              <Form.Item name="vitals_dbp" noStyle>
                <InputNumber style={{ width: '50%' }} placeholder="Dia" />
              </Form.Item>
            </Input.Group>
          </Form.Item>
        </Col>
        {/* Pulse (HR) */}
        <Col xs={12} sm={8} md={6}>
          <Form.Item name="vitals_rhr" label="HR (bpm)">
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        {/* Respiratory Rate (RR) */}
        <Col xs={12} sm={8} md={6}>
          <Form.Item name="vitals_rr" label="RR">
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        {/* Oxygen Saturation (SpO2) */}
        <Col xs={12} sm={8} md={6}>
          <Form.Item name="vitals_spo2" label="SpO2 (%)">
            <InputNumber style={{ width: '100%' }} min={0} max={100} />
          </Form.Item>
        </Col>
        {/* Temperature */}
        <Col xs={12} sm={8} md={6}>
          <Form.Item name="vitals_temp_c" label="Temp (°C)">
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        {/* Weight */}
        <Col xs={12} sm={8} md={6}>
          <Form.Item name="vitals_weight" label="Weight (kg)">
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        {/* Height */}
        <Col xs={12} sm={8} md={6}>
          <Form.Item name="vitals_height" label="Height (cm)">
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        {/* Pain Level */}
        <Col xs={12} sm={8} md={6}>
          <Form.Item name="vitals_pain" label="Pain (0-10)">
            <InputNumber style={{ width: '100%' }} min={0} max={10} />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default VitalsInputForm;
